export const OPEN_MODAL = 'modals/OPEN_MODAL';
export const CLOSE_MODAL = 'modals/CLOSE_MODAL';
export const RESET_MODAL_STATE = 'modals/RESET_MODAL_STATE';
